// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xxWuj","text":"styles_text__bNQ2Q","author":"styles_author__CVIic","info":"styles_info__CqvX+","title":"styles_title__Ga6d0"};